import { ReactNode } from 'react'
import {
    ItemContainer,
    TypographyContainer,
    StyledTypography,
    LeftIconContainer,
    RightElementContainer,
} from './SimpleMenuItem.styles'
import { Divider } from '@/ui/components/Divider/Divider.styles'

export type SimpleMenuItemProps = {
    disabled?: boolean
    action?: () => void
    text: string
    addDivider?: boolean
    leftIcon?: ReactNode
    rightElement?: ReactNode
    isTitle?: boolean
    isLastItem?: boolean
    id?: string
    onClose?: () => void
    selected?: boolean
}

const SimpleMenuItem = (props: SimpleMenuItemProps) => {
    const {
        text,
        leftIcon,
        rightElement,
        addDivider,
        disabled,
        action,
        isTitle,
        isLastItem,
        id,
        selected,
    } = props
    return (
        <ItemContainer>
            <TypographyContainer
                leftIcon={leftIcon}
                rightElement={rightElement}
                isLastItem={isLastItem}
                onClick={disabled ? undefined : action}
                disabled={disabled}
                isTitle={isTitle}
                data-testid={`simple-menu-item-clickable-${id}`}
                selected={selected}
            >
                {leftIcon && (
                    <LeftIconContainer data-testid="simple-menu-item-left-icon">
                        {leftIcon}
                    </LeftIconContainer>
                )}
                <StyledTypography
                    disabled={disabled}
                    isTitle={isTitle}
                    variant={'s-regular'}
                >
                    <p>{text}</p>
                </StyledTypography>
                {rightElement && (
                    <RightElementContainer data-testid="simple-menu-item-right-element">
                        {rightElement}
                    </RightElementContainer>
                )}
            </TypographyContainer>
            {addDivider && (
                <Divider
                    data-testid="simple-menu-item-divider"
                    margin="0 0 12px 0"
                />
            )}
        </ItemContainer>
    )
}

export default SimpleMenuItem
